module.exports = __webpack_public_path__ + "3432c14f6c345f56b5945c39fd6d7dec.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/drum-s.png
// module id = 1881
// module chunks = 0